<div class="main-screen-container">
    <div class="top-row">
        <h3 class="w-100">Lista zaproszeń</h3>
            <div class="d-flex flex-row gap-3">
                <mat-form-field appearance="outline">
                    <mat-label style="color: gray;">Szukaj...</mat-label>
                    <input #input matInput (input)="doFilter(input.value)" [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" >
      @for (invitation of dataSource.filteredData; track invitation ) {
        <mat-option (onSelectionChange)="doFilter(invitation.email)" [value]="invitation.email">{{invitation.email}}</mat-option>
      }
    </mat-autocomplete>
                </mat-form-field>
                
            </div>
            <div class="d-flex flex-row gap-3 flex-fill justify-content-end">
                <button mat-flat-button class="btn-with-icon big-button" color="accent" (click)="openUserList()"> <mat-icon>mail</mat-icon> Lista użytkowników</button>
                <button mat-flat-button class="btn-with-icon big-button" color="accent" (click)="openModal()"> <mat-icon>mail</mat-icon> Wyślij zaproszenie</button>
                <button mat-flat-button class="big-button" color="accent" (click)="fetchInvitations()"><img
                        style="width:25px;" src="/assets/img/reload.png" alt=""></button>
            </div>
    </div>

<mat-card class="list-container">
        <mat-card-content >
            <table mat-table matSort [dataSource]="dataSource" class="common-table">

                <!-- name Column -->
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> EMAIL</th>
                    <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                </ng-container>

                <!-- email Column -->
                <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> ROLA </th>
                    <td mat-cell *matCellDef="let element"> {{element.namedRole}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
                    <td mat-cell *matCellDef="let element"> {{element.status}}</td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="expires_at">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>WYGASA</th>
                    <td mat-cell *matCellDef="let element"> {{element.expires_at}}</td>
                </ng-container>

                <!-- Status of account Column -->
                <ng-container matColumnDef="created_at">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>UTWORZONE</th>
                    <td mat-cell *matCellDef="let element"> {{element.created_at}}</td>
                </ng-container>

                <!-- Status of account Column -->
                <ng-container matColumnDef="inviter">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>ZAPROSZONY PRZEZ</th>
                    <td mat-cell *matCellDef="let element"> {{element.inviter.name + ' ' + element.inviter.surname}}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>AKCJE</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="action-cell">
                            <button class="btn btn-primary btn-action" (click)="invitationDetails(element.id)"><mat-icon>pageview</mat-icon></button>
                            <button class="btn btn-primary btn-action" (click)="onResendInvitation(element.id, element.email)"><mat-icon>replay</mat-icon></button>
                            <button class="btn btn-danger btn-action" (click)="onCancelInvitation(element.id, element.email)"><mat-icon>delete</mat-icon></button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <br>
            <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons aria-label="Wybierz stronę">
            </mat-paginator>
    </mat-card-content>
    </mat-card>
</div>

